module.exports = __webpack_public_path__ + "nr.svg?61a42463d2f4031baee80bfbb4976079";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/nr.svg
// module id = 1292
// module chunks = 0